import { Button, Modal } from 'antd';
import { ReactComponent as InformationIcon } from '@features/regional-overview/assets/regional-risk/information-icon.svg';
import { COLOR_OPTIONS, FONT_FAMILY } from 'config/style';
import styled from 'styled-components';

export const StyledInfoButton = styled(Button).attrs({ type: 'link' })`
  display: flex;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 12px;
  gap: 4px;

  &.ant-btn-variant-link,
  &.ant-btn-variant-link:not(:disabled):not(.ant-btn-disabled):hover {
    color: ${COLOR_OPTIONS.NEUTRAL_90};
  }

  .ant-btn-icon {
    svg {
      width: 18px;
      height: 18px;

      path {
        fill: ${COLOR_OPTIONS.NEUTRAL_90};
      }
    }
  }
`;

export const StyledInfoModal = styled(Modal)`
  .ant-modal-header {
    .ant-modal-title {
      font-family: ${FONT_FAMILY};
    }
  }
`;

export const ModalContentWrapper = styled.div`
  font-family: ${FONT_FAMILY};
  font-size: 14px;
`;

export const RiskLevelBadgesContainer = styled.div`
  display: flex;
  margin: 8px 0;
  gap: 0;
  width: 65%;
`;

export const RiskLevelBadge = styled.span<{ $background: string; $color: string }>`
  font-family: ${FONT_FAMILY};
  padding: 4px 0px;
  background: ${props => props.$background};
  color: ${props => props.$color};
  font-size: 12px;
  flex: 1 1 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PestPressureLabel = styled.p`
  font-style: italic;
  margin: 12px 0 4px 0;
  font-weight: bold;
`;

export const HowToInterpretContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const InfoIcon = styled(InformationIcon)`
  margin-right: 8px;
  width: 24px;
  height: 24px;

  path {
    fill: ${COLOR_OPTIONS.GREEN_60};
  }
`;
